module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./SignInDetailView.js"));
	}, "SignInDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SignInDetailView!./src/pages/Promote/OfflineActivity/SignIn/SignInDetail/SignInDetailView.js
// module id = 1157
// module chunks = 438